// 导入封装好的Axios
import { http } from "@/common/http.js"; //注意request.js的相对路径问题

// //获取获取招聘分类列表
// export function getMajorList(data) {
//   return http({
//     url: "/getCatlist",
//     method: "POST",
//     data: data,
//   });
// }
// // post
// export function login(data) {
//   return http({
//     url: "/users/login",
//     method: "POST",
//     data,
//   });
// }

export default class Home {
  /**
   * @描述 获取分类
   */
  static getMajorList(data) {
    return http({
      url: "/getCatlist",
      method: "POST",
      data: data,
    });
  }

  //获取城市
  static getCityList(data) {
    return http({
      url: "/getCityLit",
      method: "POST",
      data: data,
    });
  }

  //获取城市
  static getPositionList(data) {
    return http({
      url: "/getJobLit",
      method: "POST",
      data: data,
    });
  }

  //获取企业性质
  static getEnterpriseType(data) {
    return http({
      url: "/getTypesList",
      method: "POST",
      data: data,
    });
  }

  //获取学历要求
  static getEducationList(data) {
    return http({
      url: "/getEducationList",
      method: "POST",
      data: data,
    });
  }

  //筛选信息
  static getZongZhaolist(data) {
    return http({
      url: "/getZongZhaolist",
      method: "POST",
      data: data,
    });
  }

  //id获取招聘详细信息
  static GetZhaodate(data) {
    return http({
      url: "/getZhaodate",
      method: "POST",
      data,
    });
  }

  //获取小程序跳转
  static GetMiniAppUrl(data) {
    return http({
      url: "/getScheme",
      method: "POST",
      data,
    });
  }

  static getAdsByMark(data) {
    return http({
      url: "/adszone/getAdsByMark",
      method: "POST",
      data: data,
    });
  }
}
